import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PROPERTY_TYPES } from '../common/drmTypes'

interface CadastralFilterState {
  whereClause: string | null
  count: number | null
  propertyType: string | null
}

const initialState: CadastralFilterState = {
  whereClause: null,
  count: null,
  propertyType: null,
}

const cadastralFilterSlice = createSlice({
  name: 'cadastralFilter',
  initialState,
  reducers: {
    setCadastralFilter: (
      state,
      action: PayloadAction<{
        whereClause: string
        count: number
        propertyType: PROPERTY_TYPES
      }>
    ) => {
      state.whereClause = action.payload.whereClause
      state.count = action.payload.count
      state.propertyType = action.payload.propertyType
    },
    resetCadastralFilter: state => {
      state.whereClause = null
      state.count = null
      state.propertyType = null
    },
  },
})

export const { setCadastralFilter, resetCadastralFilter } =
  cadastralFilterSlice.actions
export default cadastralFilterSlice.reducer
